<template>
	<chart
		:update="update"
		:updateRight="updateRight"
		:updateHeight="updateHeight"
		:fullStatus="fullStatus"
		:mini="mini">
	</chart>
</template>
<script>
import ProfitGistogramm from "./sig-profit-chart-strategy";
export default {
    components: {
        'chart':ProfitGistogramm,
    },
    props: {
        update:{default:true},
        updateHeight:{default:true},
        updateRight:{default:true},
        fullStatus:{default:true},
        mini:{default:false}
    }
}
</script>
<style lang="less" scoped>

</style>
